// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"40489935","793":"d14fdc3e"}[chunkId] + ".chunk.js";
};